// extracted by mini-css-extract-plugin
export default {"root":"Day_root__V6rPZ","button":"Day_button__D0pZt"};